require.register("modules/m04s/m04s-activity/page-23-co/page-23-co", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page23co = _.defaults({
  initialized: function (view) {

  },
  loaded: function (view) {

  },
  playing: function (view) {

  },
  paused: function (view) {

  },
  stopped: function (view) {

  },
  completed: function (view) {
  },
  unloading: function (view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page23co;

  
});

